import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import NotfoundShape from "../../assets/images/404-shape.svg";
import confirmBg2 from "../../assets/images/bg/confirm.jpg";
// images
import confirmBg from "../../assets/images/bg/upcoming.svg";
import reload from "../../assets/images/icons/reload.svg";
// compoennst
import Header from "../../components/header";
import { forgetPasswordAction } from "../forgetPassword/actions";
import "./style.scss";
import useReactRefresh from "../../hooks/useReactRefresh";

const cookie = new Cookies();

const ForgetPasswordConfirmEmail = (props) => {
  const get_reset_email = cookie.get("forget_email");
  const handleResetEmail = () => {
    props.forgetPasswordAction(get_reset_email);
  };
  useReactRefresh();
  return (
    <>
      <Helmet>
        <title>Confirm E-mail - Clarity Cooperative</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Header className="headerStyleWhite" logoWhite />
      <div
        style={{
          background: `url(${confirmBg}) no-repeat center center / cover`,
        }}
        className="confirmEmailArea d-none"
      >
        <div
          style={{
            background: `url(${confirmBg2}) no-repeat center center / cover`,
          }}
          className="confirmEmailWrap"
        >
          <img className="confirmShape" src={NotfoundShape} alt="shape" />

          <h1>CHECK YOUR E-MAIL</h1>
          <div className="checkSpam">
            <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.16003 1H23.4457V19H1.16003V1Z" stroke="white" strokeWidth="1.71429" strokeLinecap="round" strokeLinejoin="round" />
              <path
                d="M1.16003 3.16846L11.1972 11.6387C11.5065 11.8998 11.8982 12.043 12.3029 12.043C12.7076 12.043 13.0993 11.8998 13.4086 11.6387L23.4457 3.16846"
                stroke="white"
                strokeWidth="1.71429"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Check Your Spam Folder!
          </div>
          <p>Please, check your E-mail! We’ve sent you an e-mail with a confirmation link.</p>
          <div className="resendEmail">
            Can’t find the e-mail?
            <strong onClick={handleResetEmail}>
              Resend It <img src={reload} alt="reload" />
            </strong>
          </div>
        </div>
      </div>
    </>
  );
};
export default connect(null, { forgetPasswordAction })(ForgetPasswordConfirmEmail);
